import { render, staticRenderFns } from "./IconWishlist.vue?vue&type=template&id=9741c9ba&"
import script from "./IconWishlist.vue?vue&type=script&lang=js&"
export * from "./IconWishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports